var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CabeceraModal",
    {
      attrs: { titulo: "Editar Ingreso SIM" },
      on: {
        cerrar: function($event) {
          return _vm.$emit("cerrar")
        }
      }
    },
    [
      _c("div", { staticClass: "cabeceraSim" }, [
        _c(
          "div",
          { staticClass: "botones" },
          [
            _c(
              "v-btn",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mostrarBtnVolver,
                    expression: "mostrarBtnVolver"
                  }
                ],
                staticClass: "cabeceraSimBtnVolver",
                on: { click: _vm.volv }
              },
              [_c("span", [_vm._v("Volver")])]
            ),
            _c(
              "v-btn",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mostrarBtnContinuar,
                    expression: "mostrarBtnContinuar"
                  }
                ],
                staticClass: "cabeceraSimBtnContinuar",
                attrs: { disabled: !_vm.permitirCont },
                on: { click: _vm.cont }
              },
              [_c("span", [_vm._v("Continuar")])]
            ),
            _c(
              "v-btn",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mostrarBtnGuardar,
                    expression: "mostrarBtnGuardar"
                  }
                ],
                staticClass: "cabeceraSimBtnGuardar",
                attrs: { disabled: !_vm.permitirGuard },
                on: { click: _vm.guard }
              },
              [_c("span", [_vm._v("Guardar")])]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }